<template>
  <div>
    <div class="w-all w-minw bd-sd-b hg-40 bg-c-ffffff">
      <div class="w-main m-auto">
        <div class="fr">
          <div class="hover-ucenter fl">
            <div class="top_ucenter fl fs-12 line-h40"></div>
          </div>

          <a class="fs-12 ftc-000000 line-h40 go-login more" href="/show" v-if="nickname!=null">
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>
            您好，{{nickname}}
          </a>
          <a
            class="fs-12 ftc-000000 line-h40 go-login more"
            href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
            v-if="nickname==null"
          >
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>您好，请登录
          </a>
          <a href="javascript:void(0)" @click="logout" v-if="nickname!=null" class="fs-12 ftc-000000 line-h40 m-l-4 more">[退出]</a>
          <a href="/login" v-if="nickname==null" class="fs-12 ftc-000000 line-h40 m-l-4 more"></a>
          <span class="fs-12 ftc-000000 line-h40 m-l-15">|</span>

          <div class="fr m-l-15">
            <div class="my-lesson">
              <a v-if="nickname!=null" href="/cglist" class="fl fs-12 ftc-000000 line-h40">
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
              <a
                v-if="nickname==null"
                href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
                class="fl fs-12 ftc-000000 line-h40"
              >
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>

    <div class="toppic wall mb10">
      <div class="picself wall">
        <ul>
          <li>
            <a href="/Show">首页</a>
          </li>
          <li>
            <a href="/cgzp">课改成果展评</a>
          </li>
          <li>
            <a href="/lwzp">原创成果展评</a>
          </li>
          <li>
            <a href="/lwList">上传作品</a>
          </li>
          <li>
            <a href="/hjcx">获奖查询</a>
          </li>
        </ul>

        <!-- <a class="uploadfile"  href="/bmcs">上传作品</a> -->
      </div>
    </div>
    <div class="main w1200">
      <div class="w1200">
        
        <div class="bg">
          <div  style="text-align: center;">
            <p class="f16" style="padding:30px 30px;">如果您在语文教育领域有未公开的原创成果，欢迎您参加——</p>
           
              <img id="cgzp" src="../assets/images/title_lwzp.png" />
           
          </div>
          
          <div class="f14 of" style="padding:30px 45px;">
            <p class="f14 of" style="font-size:17px">
              <b>一、征稿对象</b>
              <br />1.中小学语文教师、语文教研员。
              <br />2.高校语文学科及语文教育专业的教师、学生。
              <br />3.中职院校语文教师。
             <br /> 4.语文教育报刊编辑。
             <br />5. “跨学科学习”专题征文同时面向其他学科老师。
              <br />
              <b>二、征稿说明</b>
              <br />1.参评作品为未正式发表的教学论文、教学设计、教学随笔、创意写作文章等。

              <br />2.来稿可自择角度，自拟题目；倡导学术性与实践性并重；内容切实具体，文风扎实严谨；知网查重须在20%以内。
              <br />3.参评作品必须保证是本人原创，不得抄袭他人成果、侵犯他人版权。
              <br />
              <b>三、参评要求</b>
              <br />1.作品信息 
              <br />参评作品中应注明作者姓名、学历、学段、教龄、职务、职称、工作单位、收件地址（涉及获奖证书邮寄，一定要详细）、邮编、手机、电子邮箱等信息。
               <br />2.作品格式与篇幅
               <br />参评作品均要求word格式，篇幅：学术论文一般不少于3000字，教学设计、教育叙事、教学随笔、跨学科专题征文一般不少于2000字（评奖以质为优，字数只作一般性考量）。注意：学术论文须符合学术论文规范（包含内容摘要、关键词、参考文献等部分，参考文献须置于论文最后），查重率在20%以内。教学设计、教育叙事、专题征文等应凸显课改精神，立足实际学情。创意写作重在创造性呈现。
            </p>
           <p class="f14 of" style="padding-left:20px;margin-top:-10px;">
     
            </p>

            <p class="f14 of" style="padding-left:20px;margin-top:-10px;margin-bottom:5px;">
             
            </p> 
             <br />
            <p class="f14 of" style="font-size:17px">
              <b>四、参评办法</b>
              <br />1.参评者须登录语文报社官网语文网专用通道：https://xspx.zhyww.cn/（需通过电脑端报名参赛），点击“新时代语文教育原创成果展评”端口，完成报名、缴费、上传作品等流程。
<br />2.参评通道于2026年3月21日开启，2026年11月30日关闭。

              <br />

              <b>五、评奖程序</b>
              <br />1.作品评审分评委会初评、专家复评两个环节。2026年10月-11月评审，2026年12月公布结果。
              <br />2.2026年12月，《语文教学通讯·学术刊》、语文网和中国知网将同时刊发评选结果，公布获奖名单。

              <br />
              <b>六、参评须知</b>
              <br />1.本项活动评奖共分学术论文、教学设计、教育叙事、创意写作、专题征文五组，各组分设特等奖、一等奖、二等奖、优秀奖四个奖次。
              <br />2.获奖者将获得加盖中国语文报刊协会、语文报社、语文报社基础教育研究院、《语文教学通讯·学术刊》公章的证书。获奖者将有机会受邀参加“语文报杯”全国中青年教师课堂教学大赛学术论坛，并被聘为语文报社基础教育研究院研究员。
              <br />3.中国知网对本次活动提供大力支持，凡获一等奖以上原创获奖作品均有机会被中国知网收入《中国重要会议论文全文数据库（CPCD）》（以中国知网最后收录为准），作者将获颁知网收录证书，享受版权保护。
特别说明：原创成果参评者须在上传作品时与中国知网签署授权收录协议，未签协议者视为自动放弃知网收录。知网授权协议网址：https://autool.cnki.net/Home/#/authorSigning/signing-pc/881/854
  <br />4.《语文教学通讯·学术刊》将在2026年特辟专刊，择优发表部分原创获奖作品。
              <br />5.学术论文、教学设计、教育叙事、创意写作、专题征文每项评审费用均为300元。
             

            </p>
          </div>
          <div class="mb30" style="margin:0 auto;text-align: center;margin-bottom:20px" >
            <div style="font-size:20px;color:#ed8d79;font-weight: bold;">点击下方按钮选择选择参评作品类型，并进行缴费。</div><br><br>
           
            <el-button
              v-if="nickname!=null"
              type="primary"
              round
              @click="createNative"
              style="width:210px"
            >学术论文</el-button>
            <el-button
              v-if="nickname!=null"
              type="primary"
              round
             @click="createNative1"
              style="width:210px"
            >教学设计</el-button>
            <el-button
              v-if="nickname!=null"
              type="primary"
              round
             @click="createNative2"
              style="width:210px"
            >教育叙事</el-button>
            <el-button
              v-if="nickname!=null"
              type="primary"
              round
             @click="createNative3"
              style="width:210px"
            >创意写作</el-button>
            <el-button
              v-if="nickname!=null"
              type="primary"
              round
             @click="createNative4"
              style="width:210px"
            >专题征文</el-button>
            <a
              v-if="nickname==null"
              href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
              hover="hand"
            >
              <img id="baoming_b" src="../assets/images/baoming_b.png" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer"
      style="background:url(('../../assets/images/foot.png')) top center no-repeat;"
    >
      <div class="menu">
        <div class="box">
          <a href="http://www.zhyww.cn/ywbs/bsjj/202006/115472.html" target="_blank">关于我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115483.html"
            target="_blank"
          >联系我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115484.html"
            target="_blank"
          >版权声明</a>
        </div>

        <div class="copyright">
          <p>语文网版权所有 未经书面授权 不得复制或建立镜像 晋公网安备14010902000073号</p>
          <p>
            增值电信业务经营许可证晋B2-20030007 新出网许（晋）字005号
            <a
              href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
              target="_blank"
            >晋ICP备09011058号</a>
            <a
              href="http://webscan.360.cn/index/checkwebsite/url/www.zhyww.cn"
              name="f7c1c8d71288f01cb16d63638e8f82bc"
            >网站安全检测平台</a>
          </p>
        </div>

        <a href="http://webscan.qianxin.com/safe/detail/?query=www.zhyww.cn">
          <img
            border="0"
            src="http://webscan.qianxin.com/api/authcode?code=fd753cb81c61b4824c3645292d170f85"
            style="display: none;"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/base.css";
import "@/assets/xspx.css";
import footer from "../../src/components/footer.vue";
import { CreateNative } from "@/request/api";
export default {
  components: { footer },
  data() {
    return {
      nickname: null,
      username: null,
      centerDialogVisible: false,
      out_trade_no:null,
      username:null,
      total_fee:null,
      type:null,

    };
  },
  created() {
    var openid = sessionStorage.getItem("openid");
    // if (openid == null) {
    //   this.$router.push({ path: "/" });
    // }
    this.nickname = sessionStorage.getItem("nickname");
  },
  methods: {
    close: function() {
      this.$alert("活动已结束", "", {
        confirmButtonText: "确定"
      });
    },
    toLwlist() {
      var that = this;
      var name = sessionStorage.getItem("username");
      if (name != 0) {
        that.$router.push({ path: "/lwList" });
      } else {
        that.$router.push({ path: "/userHome" });
      }
    },
    createNative() {
      let that = this;
      that.username = sessionStorage.getItem("username");
      var userId = sessionStorage.getItem("userId");
      CreateNative({ userId: userId })
        .then(function(response) {
          console.log("response!!!:", response);
          if (response.data.result_code == "SUCCESS") {
             var out_trade_no = response.data.out_trade_no;
            var code_url = response.data.code_url;
            var total_fee = response.data.total_fee;
            sessionStorage.setItem("type", "学术论文");
            sessionStorage.setItem("out_trade_no", out_trade_no);
            sessionStorage.setItem("code_url", code_url);
            sessionStorage.setItem("total_fee", total_fee);
            that.$router.push({
              path: "/wxPay"
            });
          } else {
            that.$router.push({ path: "/lwzp" });
          }
        })
        .catch(function(reason) {
          alert("error");
        });
    },
    createNative1() {
      let that = this;
      that.username = sessionStorage.getItem("username");
      var userId = sessionStorage.getItem("userId");
      CreateNative({ userId: userId })
        .then(function(response) {
          console.log("response!!!:", response);
          if (response.data.result_code == "SUCCESS") {
             var out_trade_no = response.data.out_trade_no;
            var code_url = response.data.code_url;
            var total_fee = response.data.total_fee;
            sessionStorage.setItem("type", "教学设计");
            sessionStorage.setItem("out_trade_no", out_trade_no);
            sessionStorage.setItem("code_url", code_url);
            sessionStorage.setItem("total_fee", total_fee);
            that.$router.push({
              path: "/wxPay"
            });
          } else {
            that.$router.push({ path: "/lwzp" });
          }
        })
        .catch(function(reason) {
          alert("error");
        });
    },
    createNative2() {
      let that = this;
      that.username = sessionStorage.getItem("username");
      var userId = sessionStorage.getItem("userId");
      CreateNative({ userId: userId })
        .then(function(response) {
          console.log("response!!!:", response);
          if (response.data.result_code == "SUCCESS") {
             var out_trade_no = response.data.out_trade_no;
            var code_url = response.data.code_url;
            var total_fee = response.data.total_fee;
            sessionStorage.setItem("type", "教育叙事");
            sessionStorage.setItem("out_trade_no", out_trade_no);
            sessionStorage.setItem("code_url", code_url);
            sessionStorage.setItem("total_fee", total_fee);
            that.$router.push({
              path: "/wxPay"
            });
          } else {
            that.$router.push({ path: "/lwzp" });
          }
        })
        .catch(function(reason) {
          alert("error");
        });
    },
    createNative3() {
      let that = this;
      that.username = sessionStorage.getItem("username");
      var userId = sessionStorage.getItem("userId");
      CreateNative({ userId: userId })
        .then(function(response) {
          console.log("response!!!:", response);
          if (response.data.result_code == "SUCCESS") {
             var out_trade_no = response.data.out_trade_no;
            var code_url = response.data.code_url;
            var total_fee = response.data.total_fee;
            sessionStorage.setItem("type", "创意写作");
            sessionStorage.setItem("out_trade_no", out_trade_no);
            sessionStorage.setItem("code_url", code_url);
            sessionStorage.setItem("total_fee", total_fee);
            that.$router.push({
              path: "/wxPay"
            });
          } else {
            that.$router.push({ path: "/lwzp" });
          }
        })
        .catch(function(reason) {
          alert("error");
        });
    },
    createNative4() {
      let that = this;
      that.username = sessionStorage.getItem("username");
      var userId = sessionStorage.getItem("userId");
      CreateNative({ userId: userId })
        .then(function(response) {
          console.log("response!!!:", response);
          if (response.data.result_code == "SUCCESS") {
             var out_trade_no = response.data.out_trade_no;
            var code_url = response.data.code_url;
            var total_fee = response.data.total_fee;
            sessionStorage.setItem("type", "专题征文");
            sessionStorage.setItem("out_trade_no", out_trade_no);
            sessionStorage.setItem("code_url", code_url);
            sessionStorage.setItem("total_fee", total_fee);
            that.$router.push({
              path: "/wxPay"
            });
          } else {
            that.$router.push({ path: "/lwzp" });
          }
        })
        .catch(function(reason) {
          alert("error");
        });
    },
      logout(){
    sessionStorage.clear();
     this.$router.push({ path: "/" });
  }
  }
};
</script>
